import React, { useState, useEffect } from "react";
import { Card, Accordion, Form, Row, Col } from "react-bootstrap";
import { connect, useDispatch } from "react-redux";
import { botCriteria } from "../../../actions/const";
import { SET_BOT_SELECTED } from "../../../actions/types";
const BotSelectionView = (props)=>{

    const {bots,t} = props;
    const botList = bots.map((bot,index)=>{
            return (
                <>
                <Form.Check
                    type="radio"
                    label={bot.name + (bot.is_submitted?' (Submitted)':"")}
                    name="filter"
                    value={bot.id}
                    className="mr-3"
                    defaultChecked={false}
                    disabled={bot.is_submitted}
                    key={bot.id}
                    onChange={e =>handleChange(bot)}
                /></>
                
            )
    })
    const dispatch = useDispatch();
    const handleChange = (bot) =>{
        dispatch({
            type: SET_BOT_SELECTED,
            payload: bot,
          });
    }
    return (
        <>
         
        <Card>
            <Card.Body className="round-bg">
                <p className="mb-3 bot-stats-heading">{t("pls-sel-bot")} <a href={botCriteria} target="_blank">({t("sub-criteria")})</a></p>
                <div className="botlist-scroll">
                    {botList}
                </div>
            </Card.Body>
        </Card>
        </>
    )
};
export default connect(null)(BotSelectionView)